import { DomainError } from '../shared/DomainError';

/**
 * バリデーションエラー
 *
 * 値オブジェクト生成時のバリデーション失敗時に投げられる。
 * 既存のInvalidEmailError等と同じパターンで実装
 */
export class ValidationError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
